import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1219c288"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex flex-column position-relative custom-background-height py-5" }
const _hoisted_3 = { class: "col-12 col-md-10 col-lg-9 mx-auto" }
const _hoisted_4 = { class: "row px-4 mb-5" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-secondary mb-2" }, "Project Name:", -1))
const _hoisted_7 = {
  key: 0,
  class: "text-primary fw-normal mb-0"
}
const _hoisted_8 = { class: "col-6 text-end mt-auto" }
const _hoisted_9 = {
  key: 0,
  class: "text-secondary mb-0"
}
const _hoisted_10 = { class: "bg-light w-100 pt-5 px-4 rounded-5 shadow" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-secondary text-center fw-normal mb-5" }, " Choose your medium ", -1))
const _hoisted_12 = {
  id: "pills-tab",
  class: "nav nav-pills py-3 d-flex flex-row flex-nowrap justify-content-between overflow-auto hide-scrollbar mb-3",
  role: "tablist"
}
const _hoisted_13 = ["id", "data-bs-target", "aria-controls"]
const _hoisted_14 = { class: "py-2 col-6 mx-auto" }
const _hoisted_15 = { class: "ratio ratio-1x1" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "text-secondary text-center mt-3 mb-0 opacity-75" }
const _hoisted_18 = {
  id: "pills-tabContent",
  class: "tab-content"
}
const _hoisted_19 = ["id", "aria-labelledby"]

import { onMounted, ref, computed, onBeforeMount } from "vue";
import TextStimuli from "@/components/projects/stimuli/TextStimuli.vue";
import VideoStimuli from "@/components/projects/stimuli/VideoStimuli.vue";
import SoundStimuli from "@/components/projects/stimuli/SoundStimuli.vue";
import ImageStimuli from "@/components/projects/stimuli/ImageStimuli.vue";
import ClickableImageStimuli from "@/components/projects/stimuli/ClickableImageStimuli.vue";

import { storeToRefs } from "pinia";
import { useProjectStimuliStore } from "@/store/ProjectStimuliStore";
// TODO change the id of the stimuli using UUID when it is allowed from backend dev
// import { UUID } from "uuid-generator-ts";
import { useRoute } from "vue-router";
import router from "@/router";


const __default__ = {
  name: "CreateStimuli",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const projectStimuliStore = useProjectStimuliStore();
const { getStimul } = projectStimuliStore;
const { project } = storeToRefs(projectStimuliStore);
const activeTab = ref(0);
const uuid = ref("");
const route = useRoute();

const generateStimuliId = () => {
  const randNumber = Math.floor(Math.random() * (9999 - 1000 + 1) + 1000);
  return randNumber.toString();
};

onBeforeMount(() => {
  uuid.value = generateStimuliId();
});
onMounted(async () => {
  if (project.value.id === null) {
    await router.push({ name: "CreateProject" });
    return;
  }
  if (route.params.stimulId === undefined) return;
  const stimul = getStimul(route.params.stimulId);
  activeTab.value = navPillsData.value.indexOf(
    navPillsData.value.find((item) => item.id === stimul.type)
  );
});

const navPillsData = computed(() =>
  _navPillsData.map((item, i) => ({
    ...item,
    disabled:
      item.coming || (route.name === "EditStimuli" && activeTab.value !== i),
  }))
);
const _navPillsData = [
  {
    id: "image",
    image: require("../../../assets/images/stimuli/image-stimuli-symbol.svg"),
    title: "Image",
    coming: false,
  },
  {
    id: "clickable",
    image: require("../../../assets/images/stimuli/clickable-image-stimuli-symbol.svg"),
    title: "Clickable Image",
    coming: false,
  },
  {
    id: "text",
    image: require("../../../assets/images/stimuli/text-stimuli-symbol.svg"),
    title: "Text",
    coming: false,
  },
  {
    id: "video",
    image: require("../../../assets/images/stimuli/video-stimuli-symbol.svg"),
    title: "Video",
    coming: true,
  },
  {
    id: "sound",
    image: require("../../../assets/images/stimuli/sound-stimuli-symbol.svg"),
    title: "Sound",
    coming: true,
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_unref(project) !== undefined && _unref(project).projectName !== undefined)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(_unref(project).projectName), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (
                _unref(project) !== undefined &&
                _unref(project).maxAllowedRespondents !== undefined
              )
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Number of Respondents: " + _toDisplayString(_unref(project).maxAllowedRespondents), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("ul", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navPillsData), (data, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: data.id,
                class: "nav-item px-2 px-xxl-0 d-flex align-self-stretch",
                role: "presentation"
              }, [
                _createElementVNode("div", {
                  id: data.id + '-tab',
                  "data-bs-toggle": "pill",
                  "data-bs-target": '#' + data.id,
                  role: "tab",
                  type: "button",
                  "aria-controls": data.id,
                  "aria-selected": "true",
                  class: _normalizeClass([[
                  {
                    disabled: data.disabled,
                  },
                  {
                    'opacity-50': data.disabled,
                  },
                  { active: i === activeTab.value },
                ], "nav-link shadow btn rounded-5 p-3 card-width"])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: data.image
                      }, null, 8, _hoisted_16)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(data.title), 1),
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-secondary text-center mb-0 opacity-75", {
                    'd-none': !data.coming,
                  }])
                  }, " Coming soon ", 2)
                ], 10, _hoisted_13)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navPillsData), (data, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: data.id,
                id: data.id,
                class: _normalizeClass(["tab-pane fade show", { active: i === activeTab.value }]),
                role: "tabpanel",
                "aria-labelledby": data.id + '-tab'
              }, [
                (data.id === 'image')
                  ? (_openBlock(), _createBlock(ImageStimuli, {
                      key: 0,
                      "stimuli-u-u-i-d": uuid.value
                    }, null, 8, ["stimuli-u-u-i-d"]))
                  : _createCommentVNode("", true),
                (data.id === 'clickable')
                  ? (_openBlock(), _createBlock(ClickableImageStimuli, {
                      key: 1,
                      "stimuli-u-u-i-d": uuid.value
                    }, null, 8, ["stimuli-u-u-i-d"]))
                  : _createCommentVNode("", true),
                (data.id === 'text')
                  ? (_openBlock(), _createBlock(TextStimuli, {
                      key: 2,
                      "stimuli-u-u-i-d": uuid.value
                    }, null, 8, ["stimuli-u-u-i-d"]))
                  : _createCommentVNode("", true),
                (data.id === 'sound')
                  ? (_openBlock(), _createBlock(SoundStimuli, { key: 3 }))
                  : _createCommentVNode("", true),
                (data.id === 'video')
                  ? (_openBlock(), _createBlock(VideoStimuli, { key: 4 }))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_19))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})